/**
 * Room Action Sound Effects — Web Audio API synthesized hype sounds.
 * Each action type gets a distinct dramatic sound.
 */

let audioCtx = null;

function getCtx() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioCtx;
}

function resumeCtx() {
  const ctx = getCtx();
  if (ctx.state === 'suspended') ctx.resume();
  return ctx;
}

/* ── POP YOUR OPP — Heavy bass impact + high crack ── */
function playPopYourOpp() {
  const ctx = resumeCtx();
  const t = ctx.currentTime;

  // Sub bass hit
  const bass = ctx.createOscillator();
  const bassGain = ctx.createGain();
  bass.type = 'sine';
  bass.frequency.setValueAtTime(80, t);
  bass.frequency.exponentialRampToValueAtTime(30, t + 0.4);
  bassGain.gain.setValueAtTime(0.7, t);
  bassGain.gain.exponentialRampToValueAtTime(0.001, t + 0.5);
  bass.connect(bassGain).connect(ctx.destination);
  bass.start(t);
  bass.stop(t + 0.5);

  // High crack
  const crack = ctx.createOscillator();
  const crackGain = ctx.createGain();
  crack.type = 'sawtooth';
  crack.frequency.setValueAtTime(2000, t);
  crack.frequency.exponentialRampToValueAtTime(200, t + 0.15);
  crackGain.gain.setValueAtTime(0.35, t);
  crackGain.gain.exponentialRampToValueAtTime(0.001, t + 0.15);
  crack.connect(crackGain).connect(ctx.destination);
  crack.start(t);
  crack.stop(t + 0.2);

  // Noise burst
  const bufferSize = ctx.sampleRate * 0.08;
  const noiseBuffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
  const data = noiseBuffer.getChannelData(0);
  for (let i = 0; i < bufferSize; i++) data[i] = (Math.random() * 2 - 1) * 0.5;
  const noise = ctx.createBufferSource();
  const noiseGain = ctx.createGain();
  noise.buffer = noiseBuffer;
  noiseGain.gain.setValueAtTime(0.4, t);
  noiseGain.gain.exponentialRampToValueAtTime(0.001, t + 0.08);
  noise.connect(noiseGain).connect(ctx.destination);
  noise.start(t);
}

/* ── COME BACK FROM BEING POPPED — Triumphant rising sweep + fanfare ── */
function playComeBackPopped() {
  const ctx = resumeCtx();
  const t = ctx.currentTime;

  // Rising sweep
  const sweep = ctx.createOscillator();
  const sweepGain = ctx.createGain();
  sweep.type = 'sawtooth';
  sweep.frequency.setValueAtTime(200, t);
  sweep.frequency.exponentialRampToValueAtTime(1200, t + 0.35);
  sweepGain.gain.setValueAtTime(0.2, t);
  sweepGain.gain.setValueAtTime(0.25, t + 0.2);
  sweepGain.gain.exponentialRampToValueAtTime(0.001, t + 0.5);
  sweep.connect(sweepGain).connect(ctx.destination);
  sweep.start(t);
  sweep.stop(t + 0.5);

  // Fanfare chord (major triad)
  [523, 659, 784].forEach((freq, i) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'triangle';
    osc.frequency.setValueAtTime(freq, t + 0.3);
    gain.gain.setValueAtTime(0, t);
    gain.gain.linearRampToValueAtTime(0.2, t + 0.35);
    gain.gain.exponentialRampToValueAtTime(0.001, t + 0.9);
    osc.connect(gain).connect(ctx.destination);
    osc.start(t + 0.3);
    osc.stop(t + 0.9);
  });
}

/* ── GU THEM — Dark ominous bass + metallic ring ── */
function playGuThem() {
  const ctx = resumeCtx();
  const t = ctx.currentTime;

  // Dark bass drone
  const bass = ctx.createOscillator();
  const bassGain = ctx.createGain();
  bass.type = 'sawtooth';
  bass.frequency.setValueAtTime(55, t);
  bass.frequency.setValueAtTime(52, t + 0.2);
  bassGain.gain.setValueAtTime(0.4, t);
  bassGain.gain.exponentialRampToValueAtTime(0.001, t + 0.6);
  bass.connect(bassGain).connect(ctx.destination);
  bass.start(t);
  bass.stop(t + 0.6);

  // Metallic ring
  const ring = ctx.createOscillator();
  const ringGain = ctx.createGain();
  ring.type = 'square';
  ring.frequency.setValueAtTime(800, t);
  ring.frequency.exponentialRampToValueAtTime(400, t + 0.3);
  ringGain.gain.setValueAtTime(0.15, t);
  ringGain.gain.exponentialRampToValueAtTime(0.001, t + 0.4);
  ring.connect(ringGain).connect(ctx.destination);
  ring.start(t);
  ring.stop(t + 0.4);

  // Sub drop
  const sub = ctx.createOscillator();
  const subGain = ctx.createGain();
  sub.type = 'sine';
  sub.frequency.setValueAtTime(120, t + 0.05);
  sub.frequency.exponentialRampToValueAtTime(25, t + 0.5);
  subGain.gain.setValueAtTime(0.5, t + 0.05);
  subGain.gain.exponentialRampToValueAtTime(0.001, t + 0.5);
  sub.connect(subGain).connect(ctx.destination);
  sub.start(t + 0.05);
  sub.stop(t + 0.5);
}

/* ── ONE MIC INDIVIDUAL — Clean mic tap + spotlight reverb ── */
function playOneMicIndividual() {
  const ctx = resumeCtx();
  const t = ctx.currentTime;

  // Mic tap (short bright click)
  const tap = ctx.createOscillator();
  const tapGain = ctx.createGain();
  tap.type = 'sine';
  tap.frequency.setValueAtTime(3000, t);
  tap.frequency.exponentialRampToValueAtTime(800, t + 0.05);
  tapGain.gain.setValueAtTime(0.4, t);
  tapGain.gain.exponentialRampToValueAtTime(0.001, t + 0.08);
  tap.connect(tapGain).connect(ctx.destination);
  tap.start(t);
  tap.stop(t + 0.1);

  // Spotlight tone (single clean note)
  const tone = ctx.createOscillator();
  const toneGain = ctx.createGain();
  tone.type = 'sine';
  tone.frequency.setValueAtTime(880, t + 0.08);
  toneGain.gain.setValueAtTime(0, t);
  toneGain.gain.linearRampToValueAtTime(0.25, t + 0.12);
  toneGain.gain.exponentialRampToValueAtTime(0.001, t + 0.7);
  tone.connect(toneGain).connect(ctx.destination);
  tone.start(t + 0.08);
  tone.stop(t + 0.7);
}

/* ── ONE MIC MAN/WOMAN — Double mic tap + crowd wash ── */
function playOneMicGroup() {
  const ctx = resumeCtx();
  const t = ctx.currentTime;

  // Double tap
  [0, 0.1].forEach(offset => {
    const tap = ctx.createOscillator();
    const gain = ctx.createGain();
    tap.type = 'sine';
    tap.frequency.setValueAtTime(2500, t + offset);
    tap.frequency.exponentialRampToValueAtTime(600, t + offset + 0.05);
    gain.gain.setValueAtTime(0.35, t + offset);
    gain.gain.exponentialRampToValueAtTime(0.001, t + offset + 0.07);
    tap.connect(gain).connect(ctx.destination);
    tap.start(t + offset);
    tap.stop(t + offset + 0.08);
  });

  // Crowd wash (filtered noise)
  const bufferSize = ctx.sampleRate * 0.5;
  const noiseBuffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
  const noiseData = noiseBuffer.getChannelData(0);
  for (let i = 0; i < bufferSize; i++) noiseData[i] = (Math.random() * 2 - 1);
  const noise = ctx.createBufferSource();
  const noiseGain = ctx.createGain();
  const filter = ctx.createBiquadFilter();
  noise.buffer = noiseBuffer;
  filter.type = 'bandpass';
  filter.frequency.setValueAtTime(1000, t + 0.15);
  filter.Q.setValueAtTime(0.5, t);
  noiseGain.gain.setValueAtTime(0, t);
  noiseGain.gain.linearRampToValueAtTime(0.12, t + 0.3);
  noiseGain.gain.exponentialRampToValueAtTime(0.001, t + 0.8);
  noise.connect(filter).connect(noiseGain).connect(ctx.destination);
  noise.start(t + 0.15);
  noise.stop(t + 0.8);

  // Power chord
  [440, 554, 660].forEach(freq => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'triangle';
    osc.frequency.setValueAtTime(freq, t + 0.18);
    gain.gain.setValueAtTime(0, t);
    gain.gain.linearRampToValueAtTime(0.15, t + 0.25);
    gain.gain.exponentialRampToValueAtTime(0.001, t + 0.8);
    osc.connect(gain).connect(ctx.destination);
    osc.start(t + 0.18);
    osc.stop(t + 0.8);
  });
}

/* ── COME BACK FROM THE GU — Ascending healing tones ── */
function playComeBackGu() {
  const ctx = resumeCtx();
  const t = ctx.currentTime;

  // Ascending notes
  [330, 440, 554, 660].forEach((freq, i) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    const start = t + i * 0.12;
    osc.type = 'sine';
    osc.frequency.setValueAtTime(freq, start);
    gain.gain.setValueAtTime(0, start);
    gain.gain.linearRampToValueAtTime(0.22, start + 0.04);
    gain.gain.exponentialRampToValueAtTime(0.001, start + 0.35);
    osc.connect(gain).connect(ctx.destination);
    osc.start(start);
    osc.stop(start + 0.35);
  });

  // Warm pad underneath
  const pad = ctx.createOscillator();
  const padGain = ctx.createGain();
  pad.type = 'triangle';
  pad.frequency.setValueAtTime(220, t);
  padGain.gain.setValueAtTime(0.1, t);
  padGain.gain.exponentialRampToValueAtTime(0.001, t + 0.7);
  pad.connect(padGain).connect(ctx.destination);
  pad.start(t);
  pad.stop(t + 0.7);
}

/* ── POLL LEADER — Trophy fanfare (two bright ascending notes + sparkle) ── */
function playPollLeader() {
  const ctx = resumeCtx();
  const t = ctx.currentTime;

  // Two ascending fanfare notes
  [784, 1046].forEach((freq, i) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    const start = t + i * 0.15;
    osc.type = 'triangle';
    osc.frequency.setValueAtTime(freq, start);
    gain.gain.setValueAtTime(0, start);
    gain.gain.linearRampToValueAtTime(0.25, start + 0.04);
    gain.gain.exponentialRampToValueAtTime(0.001, start + 0.4);
    osc.connect(gain).connect(ctx.destination);
    osc.start(start);
    osc.stop(start + 0.4);
  });

  // Sparkle shimmer
  const shimmer = ctx.createOscillator();
  const shimGain = ctx.createGain();
  shimmer.type = 'sine';
  shimmer.frequency.setValueAtTime(2400, t + 0.25);
  shimmer.frequency.exponentialRampToValueAtTime(3200, t + 0.5);
  shimGain.gain.setValueAtTime(0.08, t + 0.25);
  shimGain.gain.exponentialRampToValueAtTime(0.001, t + 0.6);
  shimmer.connect(shimGain).connect(ctx.destination);
  shimmer.start(t + 0.25);
  shimmer.stop(t + 0.6);
}

/* ── Public API ── */
const SOUND_MAP = {
  pop_your_up: playPopYourOpp,
  come_back_popped: playComeBackPopped,
  gu_them: playGuThem,
  one_mic_individual: playOneMicIndividual,
  one_mic_group: playOneMicGroup,
  come_back_goo: playComeBackGu,
  poll_leader: playPollLeader,
};

export function playRoomActionSound(actionType) {
  const fn = SOUND_MAP[actionType];
  if (fn) {
    try { fn(); } catch (e) { /* audio not available */ }
  }
}

export function unlockAudio() {
  try { resumeCtx(); } catch (e) { /* audio not available */ }
}
